import type { Element, GroupElement, Page } from '@/components/canvas/document/publicTypes';

function newElementId(type: string, index: number): string {
  return `${type}-dup-${Date.now()}-${index}-${Math.random().toString(36).slice(2, 7)}`;
}

/** 深拷贝 Page 并重新生成元素 id（含 parentId、group.children） */
export function clonePageWithNewIds(source: Page, newPageId: string): Page {
  const cloned = JSON.parse(JSON.stringify(source)) as Page;
  cloned.id = newPageId;
  const now = Date.now();
  cloned.createdAt = now;
  cloned.updatedAt = now;

  const idMap = new Map<string, string>();
  cloned.elements.forEach((el, i) => {
    idMap.set(el.id, newElementId(el.type, i));
  });

  cloned.elements = cloned.elements.map((el) => remapElementIds(el, idMap));

  const blockIdMap = new Map<string, string>();
  (cloned.blocks ?? []).forEach((block, i) => {
    blockIdMap.set(block.id, newElementId(block.type, i));
  });
  cloned.blocks = (cloned.blocks ?? []).map((block) => ({
    ...block,
    id: blockIdMap.get(block.id) ?? block.id,
  }));

  return cloned;
}

function remapElementIds(el: Element, idMap: Map<string, string>): Element {
  const next: Element = {
    ...el,
    id: idMap.get(el.id) ?? el.id,
    meta: { ...el.meta },
  };
  if (next.layout.parentId && idMap.has(next.layout.parentId)) {
    next.layout.parentId = idMap.get(next.layout.parentId)!;
  }
  if (next.type === 'group') {
    const group = next as GroupElement;
    group.data = {
      ...group.data,
      children: group.data.children.map((cid) => idMap.get(cid) ?? cid),
    };
  }
  return next;
}
